import React from 'react';
import { StyleSheet, View } from 'react-native';
import VaroLogo from 'shared/components/vxl/VaroLogo/VaroLogo';
import theme from 'shared/styles/theme';

const ReceiverHeader = () => {
  return (
    <View style={styles.logoContainer}>
      <VaroLogo width={60} height={22} />
    </View>
  );
};

const styles = StyleSheet.create({
  logoContainer: {
    alignItems: 'center',
    padding: theme.spacing.l,
  },
});

export default ReceiverHeader;
